export const RQ_GET_NON_REPORTED_USER_API = {
  url:'dailyvisit/nonReportedUser/<%= divisionId %>',
  method:'GET',
  auth:true,
};
